import React from 'react';
import "./MobileNavbar.css";
import Notify from "../../../images/notify.svg";
import User from "../../../images/User_mobile.svg";
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function MobileNavbar({ onToggle,active }) {
  return (
    <div className='mobile-nav-main'>
      <div style={{position:"fixed"}} className='px-4 row top-button-main d-flex justify-content-align-items-center'>
        <div className='col-3 d-flex justify-content-start align-items-center'>
          {active==="orderlist"?
          null
          :
          active==="profile-menu"?
          <div className='d-flex justify-content-start align-items-center' style={{ cursor: 'pointer' }}>
          <ArrowBackIcon style={{ color: 'white' }} /> 
         
        </div>
          :
          <div className='d-flex justify-content-start align-items-center' onClick={onToggle} style={{ cursor: 'pointer' }}>
            <MenuIcon style={{ color: 'white' }} /> 
            {/* <div className='d-flex justify-content-between align-items-center order-main-list-left-top'>
                <h4 style={{color:"white",fontSize:"14px",marginBottom:"-5px",fontWeight:"bold"}}>INTERNATIONAL EXPORT - CARGO <span style={{fontSize:"13px",fontWeight:"600"}}>(DOOR-TO-AIRPORT)</span></h4>
              </div> */}
          </div>
          }
        </div>
        {active==="profile-menu" || active==="profile"?
        null
        :
        <div className='col-9 d-flex justify-content-end'>
        <div style={{border:"none"}}  className='top-button-right d-flex justify-content-around align-items-center'>
          <img 
            style={{ width: "15px", marginRight: "8px"}} 
            src={Notify} 
            className='img-fluid' 
            alt="Notification" 
          />
          <Link style={{padding:"8px",marginTop:"-5px"}} to="/profileMenu">
          <img 
            src={User} 
            style={{ width: "15px" }} 
            className='img-fluid' 
            alt="User" 
          />
          </Link>
        </div>
      </div>
        }
   
      </div>
    </div>
  );
}

export default MobileNavbar;
